<template>
  <b-overlay
    :show="__isOnLoad"
    variant="white"
    rounded
    opacity="0.70"
    spinner-variant="primary"
    spinner-small
    style="float: left; width: 100%"
  >

  

  <b-modal 
    v-if="showDevis !== null"
    v-model="showPopup"
          centered
          modal-class="app-popup-shell"
          dialog-class="app-popup-dialog"
          content-class="app-popup-content"
          body-class="app-popup-body"
          :hide-footer= "true"
          size="xl"
          title="" header-class="app-popup-header"
          >
          <Template :__object="showDevis"></Template>
  </b-modal>
  <div class="row pageHeader" >
  <div class="row subMenu">
    <b-button size="sm" v-if="showManagerItem === null" variant="danger" style="float: right; margin: 5px" :class="{ activeFilterButton: showFilter }" @click.stop="toggleFilterPanel()">Filtrer</b-button>
    <b-button size="sm" v-if="showManagerItem !== null" variant="danger" style="float: right; margin: 5px" @click="showManagerItem = null">Retour</b-button>
    <b-button size="sm" v-if="showManagerItem !== null && __inPreview !== 'TPL'" style="float: right; margin: 5px" @click="$refs.devisManager.resetPreview()">Aperçu</b-button>
    <b-button size="sm" v-if="showManagerItem !== null && __inPreview !== 'PRODS'" style="float: right; margin: 5px" @click="$refs.devisManager.addProd()">+ Ajouter produit</b-button>
    <b-button size="sm" v-if="showManagerItem !== null && __inPreview !== 'SERVICES'" style="float: right; margin: 5px" @click="$refs.devisManager.addServices()">+ Ajouter service</b-button>
    <b-button size="sm" v-if="showManagerItem !== null && showManagerItem.status !== 'TERMINE'" variant="success"  style="float: right; margin: 5px" @click="$parent.setUpdateAll(showManagerItem);">Enregistrer l'état</b-button>
    <b-button size="sm" v-if="showManagerItem !== null && showManagerItem.status !== 'TERMINE'" variant="primary"  style="float: right; margin: 5px" @click="setTermine(showManagerItem)">Cloturer</b-button>
    <b-button size="sm" v-if="showManagerItem !== null && isCanGenerate()" variant="info"  style="float: right; margin: 5px" @click="createDevis(showManagerItem)">Générer un devis</b-button>

  </div>

    <FilterDrawerShell
      :show="__editMode === false && showFilter"
      title="Filtres demandes devis"
      :count="filtredListitems.length"
      @close="closeFilterPanel"
    >
      <template #sorts>
        <div class="sortItem">
          <b-icon :class="getIsActifSort(sortFiltre.isDate.state)" icon="check-square-fill" @click="sortFiltre.isDate.state = !sortFiltre.isDate.state"></b-icon>
          <span>Date</span>
          <b-icon class="redColor" v-if="sortFiltre.isDate.state" icon="recycle" @click="sortFiltre.isDate.isUp = !sortFiltre.isDate.isUp"></b-icon>
        </div>
        <div class="sortItem">
          <b-icon :class="getIsActifSort(sortFiltre.isName.state)" icon="check-square-fill" @click="sortFiltre.isName.state = !sortFiltre.isName.state"></b-icon>
          <span>Nom</span>
          <b-icon class="redColor" v-if="sortFiltre.isName.state" icon="recycle" @click="sortFiltre.isName.isUp = !sortFiltre.isName.isUp"></b-icon>
        </div>
        <div class="sortItem">
          <b-icon :class="getIsActifSort(sortFiltre.isActivated.state)" icon="check-square-fill" @click="sortFiltre.isActivated.state = !sortFiltre.isActivated.state"></b-icon>
          <span>Etat</span>
          <b-icon class="redColor" v-if="sortFiltre.isActivated.state" icon="recycle" @click="sortFiltre.isActivated.isUp = !sortFiltre.isActivated.isUp"></b-icon>
        </div>
      </template>

      <div class="filterField">
        <label>Société</label>
        <base-input
          placeholder="Société"
          v-model="filterContainer.keySearchSte"
          type="string"
        >
        </base-input>
      </div>
    </FilterDrawerShell>
  </div>

    <div :class="getMainPanel">

      <Manager ref="devisManager" v-if="showManagerItem !== null" :__item="showManagerItem" :__admin="admin" :__userList="__userList"></Manager>
      <div
        :class="styleSublisteMode + isCurrent(index === showList)"
        v-for="(item, index) in filtredListitems"
        :key="index"
        :style="getState(item.status)"
        v-if="showManagerItem === null"
      >
        <div class="recordCard">
          <div class="recordCardTop">
            <div class="recordCardIdentity">
              <div class="recordCardNumber">DEMANDE N° {{item.num}} / {{item.exercice}}</div>
              <div class="recordCardType">{{ item.status }}</div>
            </div>

            <div class="recordCardClient">
              <div class="recordCardDate">{{ __._getDate(item.createdAt) }}</div>
              <div class="recordCardOwner">{{ item.owner && item.owner.name ? item.owner.name : 'Client non renseigné' }}</div>
            </div>

            <div class="recordCardAmount">
              <span class="recordCardAmountLabel">Suivi</span>
              <b class="recordCardAmountValue">{{ item.devis ? item.devis.length : 0 }} ligne(s)</b>
            </div>
          </div>

          <div class="recordCardBody">
            <div class="recordInfoBlock">
              <div class="recordInfoLabel">Articles demandes</div>
              <div class="recordArticlesList" v-if="item.devis && item.devis.length">
                <div v-for="(article, idx) in item.devis" :key="idx" class="recordArticleRow">
                  <span class="recordArticleQty">{{ article.qte }}</span>
                  <span class="recordArticleRef">{{ article.ref }}</span>
                  <span class="recordArticleName">{{ article.name }}</span>
                </div>
              </div>
              <div class="recordEmptyText" v-else>Aucune ligne demandée.</div>
            </div>

            <div class="recordInfoBlock">
              <div class="recordInfoLabel">Devis émis</div>
              <div class="recordLinkedList devisList">
                <Listdevis :isLightMode="true" :PID="item._id"></Listdevis>
              </div>
            </div>
          </div>

          <div class="recordCardBottom">
            <div class="recordNotif" v-if="item.notif">{{item.notif}}</div>
            <div class="recordActions">
              <b-button size="sm" variant="danger" @click="setReject(item)" v-if="['NOUVEAU', 'ACCEPTE'].includes(item.status)">Annuler</b-button>
              <b-button size="sm" @click=" setAssign(item); " v-if="isAssignable(item)">M'asigner la demande</b-button>
              <b-button size="sm" @click=" showManagerItem = item; " v-if="isEditable(item)">Editer</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-overlay>
</template>
<script>
import Vue from "vue";
import Template from "@/pages/commun/Template";
import Manager from '@/pages/commun/Manager';
import Listdevis from '@/pages/devis/index';
import FilterDrawerShell from "@/components/FilterDrawerShell.vue";
export default {
  components: {
    Manager,
    Template,
    Listdevis,
    FilterDrawerShell
  },
  props: {
    __idxOnEdition: {
      type: Number,
      default: () => {
        return -1;
      },
    },
    
    __editMode: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __isOnLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    __editMode: {
      type: Boolean,
      default: () => {
        return false;
      },
    },

    __userList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    __onSelect: {
        type: Function,
        default: () => {()=>{}},
      },
  },

  data() {
    return {
      filterContainer: { keySearchSte: "" },
      structure: { vVille: [], vBanque: [] },
      showPopup:null,
      showMenu: -1,
      showList: -1,
      showFilter: false,
      showManagerItem: null,
      admin: null,
      toEditOption: '',
      filtredListitems: [],
      selectionMode: false,
      onGoingReq:[],
      userList:[],
      showDevis: null,
      sortFiltre: {
        isDate: {state: false, isUp: true },
        isName:  {state: false, isUp: true },
        isActivated:  {state: false, isUp: true },
      }
    };
  },
  methods: {
    isCanGenerate() {
      return this.showManagerItem.devis.filter(e => e.isValide === true).length > 0
    },

    isAssignable(item) {
      if(['COMMERCIAL'].includes(this.admin.type) && item.status === 'NOUVEAU') {
        return true
      } 
      return false
    },

    isEditable(item) {
      if(item.status === 'TERMINE') {
        return false;
      }
      if(['ROOT','ADMIN'].includes(this.admin.type)) {
        return true
      } 
      if(['COMMERCIAL'].includes(this.admin.type)) {
        return item.assignedToID === this.admin._id
      } 
      return false
    },

    createDevis(item) {
      this.onGoingReq.push({});
      let $onNext = (response) => {
        const payload = response && response.data ? response.data : {};

        if (payload.isExisting === true && payload.devis) {
          this.$bvToast.toast(
            "Un devis existe deja pour cette demande.",
            {
              title: "Generation devis",
              variant: "warning",
              solid: true,
            }
          );
        }

        this.setTermine(item);
      };

      const $onError = () => {
        this.$bvToast.toast(
          "Le devis n'a pas pu être généré. Veuillez réessayer.",
          {
            title: "Génération de devis",
            variant: "danger",
            solid: true,
          }
        );
      };
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };
      this.__.httpAction({
        methode: 'POST',
        route: '/devis/setfromddevis/' + item._id,
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    setAssign(item, admin = null) {
      var assignedTo = (admin === null) ? this.admin : admin;
      var msg = (admin === null) ? "M'assigner cette demande?" : "Assigner cette demande à "+admin.name+"?"
      this.$bvModal
        .msgBoxConfirm(msg, {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Confirmer",
          cancelTitle: "Annuler",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: false,
        })
        .then((value) => {
          if (value) {
            this.$parent.setUpdateValue(item._id, 'ACCEPTE', 'status');
            this.$parent.setUpdateValue(item._id, assignedTo, 'assignedTo');
            this.$parent.setUpdateValue(item._id, assignedTo._id, 'assignedToID');
            this.$parent.setUpdateValue(item._id, 'Demande assignée a '+assignedTo.name+' le '+this.__._getDate(null), 'notif');
            
          }
        });
    },

    filtredList() {
      var ret = Array.isArray(this.__list) ? [...this.__list] : [];

      if (this.filterContainer.keySearchSte)
        ret = ret.filter((e) =>
        (((e.owner && e.owner.name) || e.name || "")).includes(this.filterContainer.keySearchSte)
        );

    
        if(this.sortFiltre.isDate.state === true) {
        if(this.sortFiltre.isDate.isUp)
          ret = ret.sort((a, b) => (new Date(a.createdAt)).getTime() - (new Date(b.createdAt)).getTime());
        else
        ret = ret.sort((a, b) => (new Date(b.createdAt)).getTime() - (new Date(a.createdAt)).getTime());
      }

        
      if(this.sortFiltre.isName.state === true) {
        if(this.sortFiltre.isName.isUp)
          ret = ret.sort((a, b) => String((a.owner && a.owner.name) || a.name || "").localeCompare(String((b.owner && b.owner.name) || b.name || "")));
        else
          ret = ret.sort((a, b) => String((b.owner && b.owner.name) || b.name || "").localeCompare(String((a.owner && a.owner.name) || a.name || "")));
      }



      if(this.sortFiltre.isActivated.state === true) {
        if(this.sortFiltre.isActivated.isUp)
        ret = ret.sort((a, b) => String(a.status).localeCompare(String(b.status)));
        else
          ret = ret.sort((a, b) => String(b.status).localeCompare(String(a.status)));
      }
      
      this.filtredListitems = ret.filter(e => e.name !== '');
      //return ret;
    },


    isCurrent(current) {
      if (this.showList !== -1) return current ? "  actif" : " flowted";
      return "";
    },

    toggleMenu(index) {
      if (this.showMenu != index) {
        this.showMenu = index;
      } else {
        this.showMenu = -1;
      }
    },

    toggleList(index) {
      if (this.showList != index) {
        this.showList = index;
      } else {
        this.showList = -1;
      }
    },

    dispatchEdit(idx) {
      this.$parent.editAction(idx);
    },

    setEdit(item) {
      this.$bvModal
        .msgBoxConfirm("M'assigner cette demande?", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Confirmer",
          cancelTitle: "Annuler",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: false,
        })
        .then((value) => {
          if (value) {
            this.$parent.setUpdateValue(item._id, 'ACCEPTE', 'status');
            this.$parent.setUpdateValue(item._id, this.admin.name, 'assignedTo');
          }
        });
      
    },
   
    setReject(item) {
      this.$bvModal
        .msgBoxConfirm("Rejeter la demande?", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Confirmer",
          cancelTitle: "Annuler",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: false,
        })
        .then((value) => {
          if (value) {
            this.$parent.setUpdateValue(item._id, 'REJETE', 'status');
            this.$parent.setUpdateValue(item._id, this.admin._id, 'assignedToID');
            this.$parent.setUpdateValue(item._id, 'Demande annulée par '+this.admin.name+' le '+this.__._getDate(null), 'notif');
          }
        });
    },

    setTermine(item) {
      this.$bvModal
        .msgBoxConfirm("Clôturer la demande? une fois clôturée la demande ne sera plus editable", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Confirmer",
          cancelTitle: "Annuler",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: false,
        })
        .then((value) => {
          if (value) {
            this.$parent.setUpdateValue(item._id, 'TERMINE', 'status');
            this.$parent.setUpdateValue(item._id, this.admin._id, 'assignedToID');
            this.$parent.setUpdateValue(item._id, 'Demande clôturée par '+this.admin.name+' le '+this.__._getDate(null), 'notif');
            this.showManagerItem = null
          }
        });
    },

    
    dispatchDelete(idx) {
      this.$bvModal
        .msgBoxConfirm("Veuillez confirmer la suppression.", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Confirmer",
          cancelTitle: "Annuler",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: false,
        })
        .then((value) => {
          if (value) {
            this.$parent.deleteAction(idx);
          }
        });
    },

    dispatchActive(idx) {
      this.$parent.toggleActivateAction(idx,1);
    },

    dispatchDesactive(idx) {
      this.$parent.toggleActivateAction(idx,0);
    },

    dispatchAdd() {
      this.$parent.addAction();
    },

    toggleFilterPanel() {
      this.showFilter = !this.showFilter;
    },

    closeFilterPanel() {
      this.showFilter = false;
    },

    getIsActif(isActif) {
      return isActif === true
        ? ""
        : "redColor";
    },

    getIsActifSort(isActif) {
      return isActif === false
        ? "grayColor"
        : "greenColor";
    },

    getState(state) {
      switch (state) {
        case 'NOUVEAU':
          return 'border-left: solid 10px #CCC;'
          break;
        case 'ACCEPTE':
          return 'border-left: solid 10px orange;'
          break;
        case 'TERMINE':
          return 'border-left: solid 10px green;'
          break;
        case 'REJETE':
          return 'border-left: solid 10px red'
          break;
        default:
          break;
      }
    },

    getTof(c) {
      return this.__.resolveMediaPath(c, "uploads/societes/No-Image.jpg");
    },
  },
  watch: {
    __isOnLoad: function () {},
  },
  computed: {
    styleSublisteMode() {
      return this.__editMode !== true
        ? "listeMode col-md-12"
        : "editMode col-md-12";
    },

    __inPreview() {
      return this.$refs?.devisManager?.inPreview;
    },

    getMainPanel() {
      if(this.showPopup === false) {
        this.toEditOption = '';
      }
      return this.showFilter === true
        ? "row mainPanelWithFilter"
        : "row mainPanelWithoutFilter";
    },

    
  },

  mounted() {
    setTimeout(()=>this.filtredList(),400);
    this.admin = Vue.$cookies.get("user");
  },

  watch: {
    __isOnLoad: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValueList")
        this.filtredList()
      },
    },
    __list: {
      deep: true,
      handler() {
        this.filtredList()
      },
    },
    __idxOnEdition: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValueList")
        this.filtredList()
      },
    },
    filterContainer: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValue")
        this.filtredList()
      },
    },
    showManagerItem: {
      deep: true,
      handler(newValue, oldValue) {
        this.$emit('allowUpdateRq', this.showManagerItem)
      },
    },
    sortFiltre: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValue")
        this.filtredList()
      },
    },
  },
};
</script>
<style scoped>
.redColor {
  color: red
}
.greenColor {
  color: green;
}
.grayColor {
  color: #CCC;
}
.editMode {
  float: left;
  padding: 1%;
  margin-bottom: 10px;
  border-radius: 10px;
  min-height: 40px;
  background-color: #fff;
}
.editMode .menu {
  float: right;
  border-radius: 10px;
  background-color: #fff;
}
.listeMode {
  padding: 1%;
  margin-bottom: 10px;
  border-radius: 10px;
  min-height: 40px;
  background-color: #fff;
}

.listeMode .menu {
  float: right;
  border-radius: 10px;
  background-color: #fff;
}
.pic {
  width: 17%;
  margin-right: 3%;
  float: left;
}
.pic img {
  border-radius: 50%;
}
.preview {
  float: left;
  font-weight: bolder;
}

.preview em {
  font-weight: lighter;
  font-size: 12px;
}

.flowted {
  filter: blur(3.5px);
}

.actif {
  filter: none;
  background-color: #131016;
}

.shop {
  margin-right: 5px;
  color: #2bffc6;
}
.service {
  margin-right: 5px;
  color: #ff8d72;
}
.lubrifiant {
  margin-right: 5px;
  color: #ffd600;
}

.carburant {
  margin-right: 5px;
  color: #b1cf0c;
}

.serachPanel {
  padding: 1%;
  background-color: #F2F2F2;
  width:100%;
}

.mainPanelWithoutFilter {
  margin-top: 100px;
}

.subMenu {
    width: 100%;
    padding-left: 10%;
    padding-right: 10%;
    background-color: black;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
    min-height: 40px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .pageHeader {
    position: fixed;
    top: 120px;
    left: 0;
    width: 100%;
    z-index:333;
    background: #f2f2f2;
    overflow: visible;
  }
  .pageHeader.row,
  .subMenu.row {
    margin-left: 0;
    margin-right: 0;
  }
  .serachPanel {
    position: fixed;
  top: 119px;
    right: 0;
    width: min(420px, calc(100vw - 36px));
    height: calc(100vh - 148px);
    overflow-x: hidden;
    overflow-y: auto;
    padding: 20px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 0;
    box-shadow: 0 22px 55px rgba(15, 23, 42, 0.2);
    border: 1px solid #dbe4f0;
    z-index: 334;
    font-size: 14px;
    animation: filterPanelReveal 0.24s ease;
  }
  .serachPanel.row {
    margin-left: 0;
    margin-right: 0;
  }
  .serachPanel [class*="col-"] {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 0 0 10px;
  }
  .filterPanelHeader {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding-bottom: 14px;
    margin-bottom: 14px;
    border-bottom: 1px solid #e2e8f0;
  }
  .filterPanelTitle {
    font-size: 21px;
    font-weight: 700;
    color: #0f172a;
  }
  .filterPanelCount {
    font-size: 14px;
    color: #64748b;
    margin-top: 4px;
  }
  .filterCloseBtn {
    background: #1f2a44;
    color: #fff;
    border: none;
    border-radius: 10px;
    font-size: 13px;
    padding: 7px 14px;
  }
  .filterQuickTools {
    padding: 14px !important;
    background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
    border: 1px solid #e2e8f0;
  border-radius: 0;
    margin-bottom: 8px;
  }
  .filterQuickTitle {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    color: #475569;
    margin-bottom: 10px;
    letter-spacing: 0.04em;
  }
  .serachPanel .form-control,
  .serachPanel .custom-select {
    width: 100%;
    min-height: 46px;
    font-size: 15px !important;
    border-radius: 12px;
  }
  .serachPanel [class*="col-"] {
    font-size: 15px;
  }

@keyframes filterPanelReveal {
  from {
    opacity: 0;
    transform: translateX(24px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (max-width: 768px) {
  .pageHeader {
    top: 50px;
  }

  .subMenu {
    padding: 6px 10px;
    justify-content: center;
  }

  .serachPanel {
    top: 119px;
    right: 0;
    width: calc(100vw - 20px);
    height: calc(100vh - 108px);
    padding: 12px;
  }

  .mainPanelWithoutFilter {
    margin-top: 110px;
  }
}
</style>

